"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setViewAutoSave = void 0;
const model_1 = require("../../model");
const command_manager_1 = require("../../command_manager");
const store_1 = require("../../exports/store");
const __1 = require("..");
const types_1 = require("../../types");
const manual_save_view_1 = require("../../commands/datasheet/manual_save_view");
exports.setViewAutoSave = {
    undoable: false,
    execute: (context, options) => {
        const { model: state, fieldMapSnapshot } = context;
        const { autoSave, viewId, viewProperty } = options;
        const datasheetId = store_1.Selectors.getActiveDatasheetId(state);
        const snapshot = store_1.Selectors.getSnapshot(state, datasheetId);
        if (!snapshot) {
            return null;
        }
        const setViewAutoSaveAction = model_1.DatasheetActions.setViewAutoSave2Action(snapshot, { viewId, autoSave });
        if (!setViewAutoSaveAction) {
            return null;
        }
        const actions = [setViewAutoSaveAction];
        if (viewProperty) {
            const manualSaveViewActions = manual_save_view_1.manualSaveView.execute(context, { cmd: __1.CollaCommandName.ManualSaveView, viewId, viewProperty });
            if (manualSaveViewActions) {
                if (manualSaveViewActions.result === command_manager_1.ExecuteResult.Fail) {
                    return manualSaveViewActions;
                }
                actions.push(...manualSaveViewActions.actions);
            }
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
            fieldMapSnapshot
        };
    },
};
//# sourceMappingURL=set_view_auto_save.js.map